import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

import { idField } from 'utils/builder/fields';

const awardsItemFields = [idField, imageField('awardImage')] as const satisfies DeepReadonly<Input[]>;

const moleculeAwardsFields = (showIf?: string) =>
  [
    {
      name: 'awardItems',
      type: 'list',
      subFields: awardsItemFields,
      showIf,
      helperText: 'List of award items to display. Each item contains an ID and an image.',
    },
  ] as const satisfies DeepReadonly<Input[]>;

export type AwardsItemConfigProps = GenerateBuilder<typeof awardsItemFields>;
export type AwardsConfigProps = GenerateBuilder<ReturnType<typeof moleculeAwardsFields>>;

export default moleculeAwardsFields;
